(function ($) {
    "use strict";
    $( document ).ready(function() {
        if( 0 < analytics.actions.length  ){
            analytics.actions.forEach( function( a ){
                let node = $( a.node )
                if( node.length > 0 ){
                    node.on( a.trigger, function( e ){
                        let data = process_data_layer( $( this ), a.event, a.datalayout )
                        window.dataLayer.push( data );
                    } )
                }else{
                    // just in case node do not exist at init
                    $( document ).on( a.trigger, a.node, function( e ){
                        let data = process_data_layer( $( this ), a.event, a.datalayout )
                        window.dataLayer.push( data );
                    } )
                }
            } )
        }
    })

    function process_data_layer( node, event, layout ){
        let data = {}
        layout.forEach( function( l ){
            var n, v = null
            if( 'child' === l[0] ){ n = node.find( l[1] ) }
            else if( 'parent' === l[0] ){ n = node.parent( l[1] ) }
            else if( 'sibling' === l[0] ){ n = node.parent().find( l[1] ) }
            else if( 'self' === l[0] ){ n = node }
            else{ n = $( l[0] ).find( l[1] ) }
            if( 0 < n.length ){
                if( 'val' === l[2] ){ v = n.val() }
                else if( 'checked' === l[2] ){ v = n.filter( ':checked' ).val()}
                else if( 'checked_html' === l[2] ){ v = n.find( ':checked' ).html() }
                else if( 'checked_label' === l[2] ){
                    v = n.parent().find( 'label[for=' + n.attr( "id" ) + ']' ).html()
                }else if( 'checked_multiple' === l[2] ){
                    v = []
                    n.filter( ':checked' ).each( function ( i, e ){
                        v.push( $(e).val() )
                    } )
                }else if( 'checked_multiple_html' === l[2] ){
                    v = []
                    n.filter( ':checked' ).each( function ( i, e ){
                        v.push( $(e).html() )
                    } )
                }else if( 'checked_multiple_label' === l[2] ){
                    v = []
                    n.filter( ':checked' ).each( function ( i, e ){
                        v.push( $( 'label[for="'+$(e).attr( "id" )+'"]' ).html() )
                    } )
                }
                else if( 'data' === l[2] ){ v = n.data( l[4] ) }
                else{ v = n.html() }
            }
            data[ l[3] ] = v
        } );
        return { event : event, ...data }
    }

} )( jQuery );
